import React from 'react';
import Canvas from '../Canvas';
import ToolbarErd from './ToolbarErd';

interface BoardErdProps {
  diagramId?: string | null;
  projectId?: string | null;
}

const BoardErd: React.FC<BoardErdProps> = ({ diagramId = null, projectId = null }) => (
  // Canvas.js is JavaScript; its ToolbarComponent type is inferred loosely, so cast is required.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <Canvas initialDiagramId={diagramId} mode="erd" projectId={projectId} ToolbarComponent={ToolbarErd as any} />
);

export default BoardErd;
